"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const styled_tools_1 = require("styled-tools");
const background_svg_1 = tslib_1.__importDefault(require("./static/img/background.svg"));
exports.Background = styled_1.default(react_core_1.Box) `
  background-color: ${styled_tools_1.prop('theme.black')};
  background-image: url('${background_svg_1.default}');
`;

//# sourceMappingURL=Background.js.map
